import { render, staticRenderFns } from "./FormatoInspeccionForm.vue?vue&type=template&id=678bbbf7"
import script from "./FormatoInspeccionForm.vue?vue&type=script&lang=js"
export * from "./FormatoInspeccionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports